import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

export const Container = styled.div`
  margin-left: auto;
  .BaSe--paragraph {
    color: ${BaSeTheme.colors.institucionais.cinzaSebrae45};
  }
`;
